export enum DepartmentsTableSortProps {
    DEPARTMEMENTS = 'name',
    CATEGORIES = 'categories',
    SUBCATEGORIES = 'subcategories',
    TYPES = 'types',
    SUBTYPES = 'subtypes'
  }
  
  export interface DepartmentsTableSearchProps {
    name: string;
  }
  